import React from 'react';
import { graphql } from 'gatsby';
import Helmet from 'react-helmet';
import SEO from '../../../components/SEO';
import Layout from '../../../layouts/index';
import ReactPlayer from 'react-player';
import HtmlParser from 'html-react-parser';
import JoinHappyCustomers from '../../../components/JoinHappyCustomers';
import { DemoFormLong } from '../../../components/DemoFormLong.jsx';
import { DemoFormShortPDFNoBackground } from '../../../components/DemoFormShortPDFNoBackground.jsx';
import MultimedialPanel from '../../../components/MultimedialPanel';


const HeadcountPlanningGuide = (props) => {
    const json = props.data.allTestimonialsJson.edges;

    function shuffle(array) {
        array.sort(() => Math.random() - 0.5);
    }

    shuffle(json);
    const location = props.location;


    return (
        <Layout bodyClass="headcount-planning-guide" ontouchstart>
            <SEO title=" How to Confidently Approach 2022 Headcount Planning | Guide | ChartHop" />
            <Helmet>
                <meta
                    name="description"
                    content="Effective headcount planning can increase growth, innovation, and employee retention. Download the guide to discover what it takes to achieve these results for your organization."
                />
                <meta property="og:url" content={`https://www.charthop.com${location.pathname}`} />
                <meta property="og:title" content="How to Confidently Approach 2022 Headcount Planning | Guide | ChartHop" />
                <meta property="og:description" content="Effective headcount planning can increase growth, innovation, and employee retention. Download the guide to discover what it takes to achieve these results for your organization." />
                <meta property="og:image" content={`https://www.charthop.com/resources/guides-ebooks/headcount-planning-guide/headcount-planning-preview.png`} />
                <meta property="og:type" content="website" />
                <meta property="og:locale" content="en_US" />
                <meta property="og:site_name" content="ChartHop" />
                {/* Twitter Card tags */}
                <meta name="twitter:title" content="How to Confidently Approach 2022 Headcount Planning | Guide | ChartHop" />
                <meta name="twitter:description" content="Effective headcount planning can increase growth, innovation, and employee retention. Download the guide to discover what it takes to achieve these results for your organization." />
                <meta name="twitter:image" content={`https://www.charthop.com/resources/guides-ebooks/headcount-planning-guide/headcount-planning-preview.png`} />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@charthop" />
                <meta name="twitter:creator" content="@charthop" />

            </Helmet>

            {/* HEADER h4*/}
            <section className="hero-dei-reporting">
                <div className="row bottom-formPDF sectionSpacing contentBlock section-big">
                    <div className="headerContent col-md-6 col-sm-12 text-left padding-left-headerContent">
                        <h1 className="h1-correct">
                            How to Confidently Approach Your 2022 Headcount Planning
                        </h1>
                    </div>
                </div>
                <div className="top-formPDF sectionSpacing contentBlock justify-content-md-start justify-content-center section-big">
                    <DemoFormShortPDFNoBackground pdfUrl={'/resources/guides-ebooks/headcount-planning-guide/Headcount-planning-Guide-2022.pdf'} source={"resources-headcount-planning-2022-PDF-contentdownload-header"} />
                </div>
            </section>

            <section className="sectionSpacing flex-centeredColumn dei-section">
                <div className="contentBlock">
                    <h2 className="text-center mt-0  sectionSpacing-Margin planForwardTitle"> 
                        Headcount planning has never been as important as it is heading into 2022, making it absolutely critical for HR to get it right. This guide will explore exactly what that takes, including:
                    </h2>
                    <div className="flex-centeredColumn contentBlock">
                        <div className="pgc1 pgc1-v2">
                            <div className="pgc2">
                                <div className="pgc3">
                                    <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                                    <p>Why headcount planning matters</p>
                                </div>
                            </div>
                            <div className="pgc2">
                                <div className="pgc3">
                                    <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                                    <p>The realities of headcount planning in 2022</p>
                                </div>
                            </div>
                            <div className="pgc2">
                                <div className="pgc3">
                                    <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                                    <p>Why headcount planning has traditionally been so complex</p>
                                </div>
                            </div>
                            <div className="pgc2">
                                <div className="pgc3">
                                    <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                                    <p>Easing complexity with best practices for strategic headcount planning</p>
                                </div>
                            </div>
                            <div className="pgc2">
                                <div className="pgc3">
                                    <img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                                    <p>What's required to give your headcount planning the strategic attention it deserves</p>
                                </div>
                            </div>
                        </div>
                        <p className="text-center my-2 planForwardSubTitle">
                            Effective headcount planning can drive faster growth, greater innovation, and promote a better employee experience that leads to increased retention. Download the guide to discover how you can achieve these results for your organization.
                        </p>
                        <p className="text-center font-italic">
                            Are you a CFO? <a href="/resources/guides-ebooks/headcount-planning-guide-cfo/">Click here</a> for the special CFO edition of our headcount planning best practices.
                        </p>
                    </div>
                </div>
            </section>

            {/* TRUSTED */}
            <section className="customer testimonial-container pt-8 pb-5 backgroundGradientContainer">
                <JoinHappyCustomers title={HtmlParser('Trusted <span class="blue-text">by</span>')}></JoinHappyCustomers>
            </section>

            <section className="sectionSpacing" id="see">
                <div className="contentBlock">
                    <MultimedialPanel
                        multimediaPosition="right"
                        title="Plan out your team"
                        link="/product/2105-refresh/performance-expectations.png"
                        type="image"
                        paddingClass="padding-top-video-two"
                        content={
                            <React.Fragment>
                                <p>Understand the structural and budgetary impact of any change across your organization:</p>
                                <div className="row pb-0 pt-0">
                                    <div className="col-lg-6 col-md-12">
                                        <p className="mb-0">
                                            <li>Create and close open roles</li>
                                            <li>Plan departures</li>
                                            <li>Propose promotions</li>
                                        </p>
                                    </div>
                                    <div className="col-lg-6 col-md-12">
                                        <p className="mb-0">
                                            <li>Restructure teams</li>
                                            <li>Merge teams </li>
                                            & so much more
                                        </p>
                                    </div>
                                </div>
                            </React.Fragment>
                        }
                    />
                </div>
            </section>

            <section className="sectionSpacing backgroundGradientContainer" id="see">
                <div className="contentBlock">
                    <MultimedialPanel
                        multimediaPosition="left"
                        title="Collaborate seamlessly"
                        link="/product/2105-refresh/scenarios-sharing.png"
                        type="image"
                        paddingClass="padding-top-video-two"
                        content={
                            <React.Fragment>
                                <p>Centralize your changes and discussions in one place.</p><p> Collaborate with stakeholders all within the platform, without emailing spreadsheets and powerpoints back and forth. </p>
                            </React.Fragment>
                        }
                    />
                </div>
            </section>

            <section className="sectionSpacing" id="see">
                <div className="contentBlock">
                    <MultimedialPanel
                        multimediaPosition="right"
                        title="Analyze impact"
                        link="/product/2105-refresh/scenarios-reports.png"
                        type="image"
                        paddingClass="padding-top-video-two"
                        content={
                            <React.Fragment>
                                <p>Forget manual spreadsheets filled with complex models.</p><p> Build your future team visually and understand the impact across all your KPIs. Finally align People, Finance, Recruiting and hiring managers.</p>
                            </React.Fragment>
                        }
                    />
                </div>
            </section>

            {/* AVAILABLE INTEGRATIONS */}
            <section className="backgroundGradientContainer-Reverse sectionSpacing flex-centeredColumn">
                <h2 className="text-center mt-0 sectionSpacing-Margin">Built to augment your existing tools.</h2>



                <div className="moreIntegrationsContent">
                    <div className="floating-minorCardContainer">
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-bamboo@2x.jpg' alt="BambooHR" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-slack@2x.jpg' alt="Slack" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-workday@2x.jpg' alt="Workday" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-successfactors@2x.jpg' alt="Success Factors" />
                            </div>
                        </div>
                        {/* FIRST 4 */}

                        <div>
                            <div>
                                <img src='/integrations/logos/logo-greenhouse@2x.jpg' alt="Greenhouse" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-lever@2x.jpg' alt="Lever" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-carta@2x.jpg' alt="Carta" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-e-trade@2x.jpg' alt="E-Trade" />
                            </div>
                        </div>

                        {/* SECOND 4 */}

                        <div>
                            <div>
                                <img src='/integrations/logos/logo-trinet@2x.jpg' alt="Trinet" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/gusto.png' alt="Gusto" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-google.jpg' alt="Google" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-justworks@2x.jpg' alt="Justworks" />
                            </div>
                        </div>

                        {/* THIRD 4 */}
                        <div>
                            <div>
                                <img src='/integrations/logos/sequoia.png' alt="Sequoia" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-paylocity@2x.jpg' alt="Paylocity" />
                            </div>
                        </div>

                        <div>
                            <div>
                                <img src='/integrations/logos/logo-namely@2x.jpg' alt="Namely" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/zenefits.png' alt="Zenefits" />
                            </div>
                        </div>


                        {/* <div> */}
                        <div className="psudeo ps1">
                        </div>

                        <div className="psudeo ps2">
                        </div>

                        <div className="psudeo ps3">
                        </div>

                        <div className="psudeo ps4">

                        </div>
                        {/* </div> */}
                        <h4 className="text-center">& more</h4>
                    </div>
                </div>
            </section>



  
            {/* LONG FORM */}
            <section name="request-demo " id="request-demo" className="request-demo request-demo-white pt-3 pb-4 pt-md-8 pb-md-8">
				<DemoFormLong source={"resources-headcount-planning-2022-demo-bottom"} headertext={HtmlParser('<div class="contactTestimonial pr-md-1"><p class=" mb-3 contact-testimonial">“ChartHop helped us centralize over a hundred headcount planning spreadsheets into a single platform.</br></br> We could easily monitor people’s access, progress and consolidate multiple plans with a couple of clicks.”</p><div class="authorTag"><img src="/home/quotes/quote_AlexKoykova@2x.jpg" class="testimonialAuthor" alt="Alex Koykova" /><div><p class="contactAuthor"><strong>Alex Koykova</strong> <br>Director, People Operations<br><img src="/home/brand_logos/mongodb-logo-original.svg" alt="MongoDB" class="MongoDBauthor" /></p></div></div>')}/>
			</section>

        </Layout>
    );
};


export default HeadcountPlanningGuide;

export const query = graphql`
  query {
    allTestimonialsJson {
      edges {
        node {
          id
          name
          title
          quote
          image
        }
      }
    }
  }
`;